import { Check } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";

type UpgradeModalProps = {
  children: React.ReactNode;
};

export function UpgradeModal({ children }: UpgradeModalProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="flex max-w-5xl p-0">
        <div className="flex-1 p-4">
          <p className="text-lg font-medium text-foreground">
            Unlock the power of Premium
          </p>
          <p className="mb-6 text-sm text-muted">
            Call to action intro text should be here. It should be fairly short,
            about this length. Or a little longer so it's over two lines-ish.
          </p>
          <Button className="mb-6">Request a Call</Button>

          <div>
            <div className="overflow-hidden rounded-lg">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="p-4 text-left text-sm font-medium text-foreground">
                      What you get
                    </th>
                    <th className="p-4 text-center text-sm font-medium text-foreground">
                      Essentials
                    </th>
                    <th className="p-4 text-center text-sm font-medium text-foreground">
                      Enhanced
                    </th>
                    <th className="rounded-tl-lg bg-primary/10 p-4 text-center text-sm font-medium text-foreground">
                      Premium
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b">
                    <td className="p-2 text-sm text-foreground">
                      Recording Storage
                    </td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="bg-primary/10 p-2 text-center text-foreground">
                      <Check className="text-brand-primary mx-auto h-4 w-4" />
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="p-2 text-sm text-foreground">
                      Advanced Analytics
                    </td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="bg-primary/10 p-2 text-center text-foreground">
                      <Check className="text-brand-primary mx-auto h-4 w-4" />
                    </td>
                  </tr>
                  <tr className="border-b">
                    <td className="p-2 text-sm text-foreground">
                      Priority Support
                    </td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="bg-primary/10 p-2 text-center text-foreground">
                      <Check className="text-brand-primary mx-auto h-4 w-4" />
                    </td>
                  </tr>
                  <tr>
                    <td className="p-2 text-sm text-foreground">
                      Custom Integrations
                    </td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="p-2 text-center text-foreground">-</td>
                    <td className="rounded-bl-lg bg-primary/10 p-2 text-center text-foreground">
                      <Check className="text-brand-primary mx-auto h-4 w-4" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <img
          src="/upgrade-modal.png"
          className="h-full w-auto object-cover"
          alt="Upgrade Modal"
        />
      </DialogContent>
    </Dialog>
  );
}
